import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons';

export type BorderBoxState = 'default' | 'disabled' | 'empty' | 'highlighted' | 'droppable' | 'error';

@Component({
  selector: 'rcp-borderbox',
  host: {
    '[class.clickable]': 'clickable()',
    '[class.draggable]': 'draggable()',
    '[class.interactive]': 'interactive()',
    '[attr.data-state]': 'state()',
  },
  template: `
    @if (draggable()) {
      <fa-icon class="borderbox-drag-handle" [icon]="faEllipsisVertical" />
    }
    <ng-content />
  `,
  styleUrls: ['./borderbox.component.scss'],
  imports: [FaIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BorderboxComponent {
  readonly clickable = input(false);
  readonly draggable = input(false);
  readonly state = input<BorderBoxState>('default');

  readonly interactive = computed(() => this.state() !== 'disabled' && (this.draggable() || this.clickable()));

  protected readonly faEllipsisVertical = faEllipsisVertical;
}
